import React, {Component} from 'react';
import {DRProjectHeaderDef, DRProjectRowDef} from "../DealroomProject/helpers";
import {connect} from "react-redux";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import SelectAgGridEditor from "../../../Projects/Projects/FieldRenderer/SelectAgGridEditor";
import SelectAgGridRenderer from "../../../Projects/Projects/FieldRenderer/SelectAgGridRenderer";
import SimpleInputAgGridRenderer from "../../../Projects/Projects/FieldRenderer/SimpleInputAgGridRenderer";
import SimpleInputAgGridEditor from "../../../Projects/Projects/FieldRenderer/SimpleInputAgGridEditor";
import CheckboxAgGridEditor from "../../../Projects/Projects/FieldRenderer/CheckboxAgGridEditor";
import CustomIconsAgGrid from "../DealroomProject/CustomIconsAgGrid";
import ColDef from "ag-grid-community";
import {setError} from "../../../../store/actions";


class Index extends Component {
  state = {
    currentValues: null,
    arraySelectedProjectsId: [],
    columnDefs: [],
    rowData: [],
    defaultColDef: {
      editable: true,
      sortable: true,
      resizable: true
    },
    rowSelection: "multiple",
    getNodeChildDetails: function getNodeChildDetails(rowItem) {
      if (rowItem.participants) {
        return {
          group: true,
          expanded: false,
          children: rowItem.participants,
          key: rowItem.pname,

        };
      } else {
        return null;
      }
    },
    frameworkComponents: {
      checkboxAgGridEditor: CheckboxAgGridEditor,
      customIcons: (params) => <CustomIconsAgGrid params={params}/>,
      selectAgGridEditor: SelectAgGridEditor,
      selectAgGridRenderer: SelectAgGridRenderer,
      simpleInputAgGridRenderer: SimpleInputAgGridRenderer,
      simpleInputAgGridEditor: SimpleInputAgGridEditor,
    },
    cellRendererSelector: ColDef,
    cellEditorSelector: ColDef,
  };

  componentDidMount() {
    const {project, projectIndex, keepProjectData} = this.props;
    const columnDefs = DRProjectHeaderDef(project, projectIndex,true);
    const rowData = DRProjectRowDef([project], projectIndex,true);
    keepProjectData(rowData[0],projectIndex);
    this.setState({columnDefs, rowData, currentValues: rowData[0]})
  }

  componentDidUpdate(prevProps) {
    const {project, projectIndex,keepProjectData} = this.props;

    if (project.id !== prevProps.project.id) {
      const columnDefs = DRProjectHeaderDef(project, projectIndex,true);
      const rowData = DRProjectRowDef([project], projectIndex,true);
      keepProjectData(rowData[0],projectIndex);
      this.setState({columnDefs, rowData, currentValues: rowData[0]})
    }
  }

  currentValuesChanges = (data) => {
    const {projectIndex,keepProjectData} = this.props;

    keepProjectData(data,projectIndex);
    this.setState({currentValue: data});
  };

  render() {
    const {setError} = this.props;
    const {
      defaultColDef, rowSelection, getNodeChildDetails,
      frameworkComponents, columnDefs, rowData
    } = this.state;

    return (
      <React.Fragment>
        <div className="ag-theme-material"
             style={{
               height: "200px",
               width: "100%",
               marginTop: "50px",
               border: "2px solid #60bee1"
             }}>
          <div style={{overflowX: 'scroll', height: '100%'}}>
            <AgGridReact
              columnDefs={columnDefs}
              groupSelectsChildren={true}
              enableRangeSelection={true}
              animateRows={true}
              rowData={rowData}
              currentValuesChanges={this.currentValuesChanges}
              changeProjectData={this.changeProjectData}
              setError={setError}
              enableGroupEdit={true}
              singleClickEdit={true}
              defaultColDef={defaultColDef}
              rowSelection={rowSelection}
              getNodeChildDetails={getNodeChildDetails}
              frameworkComponents={frameworkComponents}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(null, {setError})(Index);


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/ScenarioProjects/ScenarioProjects.js